import React from 'react';
import OnBoardForm from '../components/onBoardingForms/OnBoardForm';
import { Box } from '@mui/material';


const onBoardingFormContainer = () => {
    return (
        <Box>
            <OnBoardForm />
        </Box>

    )
}

export default onBoardingFormContainer
